import { compiler as array } from "./array/compiler";
import { compiler as boolean } from "./boolean/compiler";
import { compiler as enumeration } from "./enum/compiler";

export const Compiler = {
  boolean,
  enum: enumeration,
  array
} as const;